/** CoStar.Api.LoopNet.MobileServices.ViewModels.Search.AssetType */
export var AssetType;
(function (AssetType) {
    AssetType[AssetType["Properties"] = 0] = "Properties";
    AssetType[AssetType["Notes"] = 1] = "Notes";
})(AssetType || (AssetType = {}));
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Search.TriState */
export var TriState;
(function (TriState) {
    TriState[TriState["Include"] = 0] = "Include";
    TriState[TriState["Only"] = 1] = "Only";
    TriState[TriState["Exclude"] = 2] = "Exclude";
})(TriState || (TriState = {}));
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Search.InvestmentType */
export var InvestmentType;
(function (InvestmentType) {
    InvestmentType[InvestmentType["None"] = 0] = "None";
    InvestmentType[InvestmentType["Core"] = 1] = "Core";
    InvestmentType[InvestmentType["ValueAdd"] = 2] = "ValueAdd";
    InvestmentType[InvestmentType["Opportunistic"] = 4] = "Opportunistic";
    InvestmentType[InvestmentType["TripleNet"] = 8] = "TripleNet";
    InvestmentType[InvestmentType["OpportunityZone"] = 16] = "OpportunityZone";
})(InvestmentType || (InvestmentType = {}));
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Search.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["Default"] = 0] = "Default";
    SortType[SortType["Newest"] = 1] = "Newest";
    SortType[SortType["Oldest"] = 2] = "Oldest";
    SortType[SortType["PriceLowest"] = 3] = "PriceLowest";
    SortType[SortType["PriceHighest"] = 4] = "PriceHighest";
    SortType[SortType["RentLowest"] = 5] = "RentLowest";
    SortType[SortType["RentHighest"] = 6] = "RentHighest";
    SortType[SortType["CapRateLowest"] = 7] = "CapRateLowest";
    SortType[SortType["CapRateHighest"] = 8] = "CapRateHighest";
    SortType[SortType["BuildingAreaLowest"] = 9] = "BuildingAreaLowest";
    SortType[SortType["BuildingAreaHighest"] = 10] = "BuildingAreaHighest";
    SortType[SortType["AvailableSpaceLowest"] = 11] = "AvailableSpaceLowest";
    SortType[SortType["AvailableSpaceHighest"] = 12] = "AvailableSpaceHighest";
    SortType[SortType["CityAscending"] = 13] = "CityAscending";
    SortType[SortType["CityDescending"] = 14] = "CityDescending";
    SortType[SortType["HasVideo"] = 15] = "HasVideo";
    SortType[SortType["RecentlyUpdated"] = 16] = "RecentlyUpdated";
    SortType[SortType["Has3DTour"] = 17] = "Has3DTour";
    SortType[SortType["ListingIdCriteriaOrder"] = -1] = "ListingIdCriteriaOrder";
})(SortType || (SortType = {}));
import { AlertFrequencyType } from "../../../../../../CoStar/Api/ListingAlert/ViewModels/Enums/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Search.AlertFrequencyType */
export { AlertFrequencyType };
